import type { LebenVersicherungsVertrag } from 'ods-api'
import { getToken } from '@/utils/KeycloakUtils'
import { generateUUID } from '@/utils/utils'

export async function fetchOdsContractByContractId(
  contractId: string,
  correlationId: string = generateUUID()
): Promise<LebenVersicherungsVertrag> {
  const token = await getToken()
  return fetch(`${globalThis.ENV_CONFIG?.ODS_HOSTS.LIFE}/life-contracts/${contractId}`, {
    headers: {
      correlationId: correlationId,
      Authorization: `Bearer ${token}`,
      KeyId: globalThis.ENV_CONFIG?.API_KEY,
      'Content-Type': 'application/json'
    },
    method: 'GET'
  }).then((response) => {
    if (!response.ok) {
      throw new Error(response.statusText)
    }
    return response.json()
  })
}
